import { Extension } from '@tiptap/core';
import type { Node as PMNode } from '@tiptap/pm/model';
import { TextSelection } from '@tiptap/pm/state';

type CellTextRange = { from: number; to: number };

/** Selecteert alleen de inhoud van de actieve investeringscel. */
export function activeInvestmentCellTextRange(doc: PMNode, anchor: number): CellTextRange | null {
  const $anchor = doc.resolve(anchor);
  let cellDepth = -1;
  let insideInvestment = false;

  for (let depth = $anchor.depth; depth >= 1; depth--) {
    const name = $anchor.node(depth).type.name;
    if (cellDepth < 0 && (name === 'tableCell' || name === 'tableHeader')) {
      cellDepth = depth;
    }
    if (name === 'investmentGroupNode') insideInvestment = true;
  }

  if (!insideInvestment || cellDepth < 0) return null;

  const cell = $anchor.node(cellDepth);
  const cellStart = $anchor.before(cellDepth);
  let from: number | null = null;
  let to: number | null = null;

  cell.descendants((node, relativePos) => {
    if (!node.isTextblock) return true;
    const textStart = cellStart + 1 + relativePos + 1;
    if (from == null) from = textStart;
    to = textStart + node.content.size;
    return false;
  });

  return from == null || to == null ? null : { from, to };
}

export const InvestmentCellShortcuts = Extension.create({
  name: 'investmentCellShortcuts',
  priority: 1100,

  addKeyboardShortcuts() {
    return {
      'Mod-a': () => {
        const { state, view } = this.editor;
        const range = activeInvestmentCellTextRange(state.doc, state.selection.from);
        if (!range) return false;

        view.dispatch(state.tr.setSelection(TextSelection.create(state.doc, range.from, range.to)));
        return true;
      },
    };
  },
});

export default InvestmentCellShortcuts;
